import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../../../hooks/axiosInstance";

export default function CreateAccount({ show, closeModal, refreshPage }) {
    const [validationError, setValidationError] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        account_name: "",
        bank: "",
        account_number: "",
    });

    const resetForm = () => {
        setFormData({
            account_name: "",
            bank: "",
            account_number: "",
        });
        setValidationError({});
    };

    const handleChange = (e) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [e.target.name]: e.target.value,
        }));
    };

    const handleClose = () => {
        resetForm();
        closeModal();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            await axiosInstance.post("/user/bank_account/create", formData);
            toast.success("Bank account created successfully!");
            handleClose();
            refreshPage();
        } catch (error) {
            console.error("Error submitting form:", error);
            if (error.response && error.response.data.errors) {
                setValidationError(error.response.data.errors);
                toast.error("Failed to save.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="CreateAccount">
            <Modal show={show} onHide={handleClose} dialogClassName="modal-md">
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Bank Account</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3" controlId="formAccountName">
                            <div>
                                <h6>Account Name</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter account name"
                                name="account_name"
                                value={formData.account_name}
                                onChange={handleChange}
                            />
                            {validationError.account_name && (
                                <small className="text-danger my-1">
                                    {validationError.account_name[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBank">
                            <div>
                                <h6>Bank</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter bank"
                                name="bank"
                                value={formData.bank}
                                onChange={handleChange}
                            />
                            {validationError.bank && (
                                <small className="text-danger my-1">
                                    {validationError.bank[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formAccountNumber">
                            <div>
                                <h6>Account Number</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter account number"
                                name="account_number"
                                value={formData.account_number}
                                onChange={handleChange}
                            />
                            {validationError.account_number && (
                                <small className="text-danger my-1">
                                    {validationError.account_number[0]}
                                </small>
                            )}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            style={{
                                backgroundColor: "#c4281b",
                                color: "#fff",
                                border: "none",
                            }}
                            type="submit"
                            disabled={isLoading}
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}
